import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import Index from './views/products/FanList.vue'
import ProductFastSearch from './views/products/ProductFastSearch.vue'
import FanCoil from './views/products/FanCoil.vue'
import IndoorUnit from './views/products/IndoorUnit.vue'
import AirOutlet from './views/products/AirOutlet.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const routes = [
  // 选型快速搜索落地页
  {
    path: '/',
    name: 'Index',
    component: ProductFastSearch,
    meta: {
      title: '产品库',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 标明该路由属于哪个模块：产品：product；材料：material；模块库：module；构件库：component； 公共页面可以没有该属性
      module: 'product',
      documentTitle: '产品库',
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  {
    path: '/multiRoom/fanCoil',
    name: 'fanCoil',
    component: FanCoil,
    meta: {
      title: '风机盘管',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  {
    path: '/multiRoom/indoorUnit',
    name: 'indoorUnit',
    component: IndoorUnit,
    meta: {
      title: '室内机',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  {
    path: '/multiRoom/airOutlet',
    name: 'airOutlet',
    component: AirOutlet,
    meta: {
      title: '末端风口',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  {
    path: '/startSearch',
    name: 'StartSearch',
    component: ProductFastSearch,
    meta: {
      title: '产品库',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 标明该路由属于哪个模块：产品：product；材料：material；模块库：module；构件库：component； 公共页面可以没有该属性
      module: 'product',
      documentTitle: '产品库',
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  // 选风机
  {
    path: '/fan',
    name: 'FanList',
    component: Index,
    meta: {
      title: '通风机',
      showMenu: true,
      // 是否显示已选购物车
      showBasket: false,
      // 当前路由跳往特定页面时，需keepAlive当前页面
      aliveTo: ['ProductDetail', 'SelectionList', 'DocDetail'],
      /** 有aliveTo的时候，keepAlive必须给初始值true（作用是防止第一次进入需要缓存的页面时，无法缓存）
       * */
      keepAlive: true,
      // 标明该路由属于哪个模块：产品：product；材料：material；模块库：module；构件库：component； 公共页面可以没有该属性
      module: 'product',
      documentTitle: '产品库',
    }
  },
  // 选风机（兼容插件老版本的路由）
  {
    path: '/products',
    name: 'Products',
    component: () => import('./views/products/FanList.vue'),
    meta: {
      title: '通风机',
      showMenu: true,
      showBasket: false,
      // 当前路由跳往特定页面时，需keepAlive当前页面
      aliveTo: ['ProductDetail', 'SelectionList', 'DocDetail'],
      keepAlive: true,
      module: 'product',
      documentTitle: '产品库',
    }
  },
  // 选水泵
  {
    path: '/pump',
    name: 'PumpList',
    component: () => import('./views/products/PumpList.vue'),
    meta: {
      title: '水泵',
      showMenu: true,
      showBasket: false,
      // 当前路由跳往特定页面时，需keepAlive当前页面
      aliveTo: ['ProductDetail', 'SelectionList', 'DocDetail'],
      keepAlive: true,
      module: 'product',
      documentTitle: '产品库',
    }
  },
  // 通用产品列表页
  {
    path: '/productList/:categoryCode',
    name: 'ProductList',
    component: () => import('./views/products/ProductList.vue'),
    meta: {
      title: '通用产品列表页',
      showMenu: true,
      showBasket: false,
      // 当前路由跳往特定页面时，需keepAlive当前页面
      aliveTo: ['ProductDetail', 'SelectionList', 'DocDetail'],
      keepAlive: true,
      module: 'product',
      documentTitle: '产品库',
    }
  },
  // 产品详情
  {
    path: '/product/detail/:id',
    name: 'ProductDetail',
    component: () => import('./views/products/Detail.vue'),
    meta: {
      title: '产品详情页',
      showMenu: false,
      showBasket: false,
      aliveTo: ['DocDetail'],
      keepAlive: true,
      module: 'product',
      documentTitle: '产品库',
    }
  },
  {
    path: '/fanCoil/multiRoom',
    name: 'fanCoil',
    component: FanCoil,
    meta: {
      title: '风机盘管',
      showMenu: false,
      // 是否显示已选购物车
      showBasket: false,
      // 标明该路由属于哪个模块：产品：product；材料：material；模块库：module；构件库：component； 公共页面可以没有该属性
      module: 'product',
      documentTitle: '产品库',
      // 进入该页面是否忽略登录检验
      ignoreLogin: true
    }
  },
  // 已选中的产品列表
  {
    path: '/selectedProducts',
    name: 'SelectionList',
    component: () => import('./views/selections/SelectionList.vue'),
    meta: {
      title: '已选产品列表',
      showMenu: false,
      // 当前路由跳往特定页面时，需keepAlive当前页面
      aliveTo: ['ProductDetail'],
      keepAlive: true,
      module: 'product',
      documentTitle: '产品库',
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('./views/docs/Index.vue'),
    meta: {
      title: '电子手册',
      showMenu: true,
      showBasket: false,
      aliveTo: ['DocDetail'],
      keepAlive: true,
    }
  },
  {
    path: '/doc-detail',
    name: 'DocDetail',
    component: () => import('./views/docs/Detail.vue'),
    meta: {
      title: '手册详情',
      showMenu: false,
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('./views/Error.vue'),
    meta: {
      title: '错误页',
      showMenu: false,
    }
  },
  /**  材料库 **/
  {
    path: '/material',
    name: 'MaterialList',
    component: () => import('./views/materials/MaterialList.vue'),
    meta: {
      title: '标准材料库',
      // 某些平台特有的页面
      platform: ['g'],
      module: 'material',
      documentTitle: '标准材料库',
    }
  },
  /**  模块库 **/
  {
    path: '/module',
    name: 'ModuleList',
    component: () => import('./views/modules/ModuleList.vue'),
    meta: {
      title: '模块库',
      // 某些平台特有的页面
      platform: ['g', 'web'],
      module: 'module',
      documentTitle: '模块库',
    }
  },
  {
    path: '/goods',
    name: 'GoodsList',
    component: () => import('./views/goods/Index.vue'),
    meta: {
      title: '价格查询',
      // 某些平台特有的页面
      platform: ['g'],
    }
  },
  /**  构件库 **/
  {
    path: '/components',
    name: 'ComponentList',
    component: () => import('./views/components/Index.vue'),
    meta: {
      title: '构件库',
      platform: ['g', 'cs', 'web'],
      module: 'component',
      documentTitle: '构件库',
    }
  },
  /**  做法库 **/
  {
    path: '/practice',
    name: 'PracticeList',
    component: () => import('./views/practice/PracticeList.vue'),
    meta: {
      title: '工程做法库',
      // 某些平台特有的页面
      platform: ['g'],
      module: 'practice',
      documentTitle: '工程做法库',
    }
  },
  /**  模板库 **/
  {
    path: '/scheme',
    name: 'SchemeList',
    component: () => import('./views/scheme/SchemeList.vue'),
    meta: {
      title: '模板库',
      // 某些平台特有的页面
      platform: ['g', 'web'],
      module: 'scheme',
      documentTitle: '模板库',
    }
  },
  /**  专题场景库 **/
  {
    path: '/scenes',
    name: 'SceneList',
    component: () => import('./views/scene/SceneList.vue'),
    meta: {
      title: '专题场景库',
      // 某些平台特有的页面
      platform: ['g', 'web'],
      // 免登陆的平台
      ignoreLogin: ['web'],
      module: 'scene',
      documentTitle: '专题场景库',
    }
  },
  {
    path: '/scenes/:id/components',
    name: 'SceneComponentList',
    component: () => import('./views/scene/SceneComponentList.vue'),
    meta: {
      title: '专题场景构件',
      // 某些平台特有的页面
      platform: ['g', 'web'],
      // ignoreLogin: ['web'],
      module: 'scene',
      documentTitle: '专题场景库',
    }
  },

  {
    path: '*',
    redirect: '/error'
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 本地环境不需要百度站点统计
if (process.env.NODE_ENV === 'production') {
  router.beforeEach((to, from, next) => {
    if (to.path) {
      if (window._hmt) {
        window._hmt.push(['_trackPageview', '/selection#' + to.fullPath])
      } else {
        window._hmt = [];
        (() => {
          const hm = document.createElement('script')
          hm.src = 'https://hm.baidu.com/hm.js?e02c5a587e9fa0128d855b33e027eb00'
          const s = document.getElementsByTagName('script')[0]
          s.parentNode.insertBefore(hm, s)
        })()
      }
    }
    next()
  })
}

router.afterEach((to, from) => {
  document.title = to.meta.documentTitle || to.meta.title || '产品库'
  const aliveTo = from.meta.aliveTo || []
  from.meta.keepAlive = aliveTo.includes(to.name)
  store.commit('setShowShopAnimation', false)
  // 如果与平台路由不相符，则跳转到error页面
  const routePlatform = to.meta.platform
  if (routePlatform && !routePlatform.includes(store.getters.platform)) {
    router.replace({ name: 'Error' })
  }
})

export default router
